import { removeDuplicates } from 'utils/array';

const getAllTypes = (loads) =>
  removeDuplicates(loads.map((load) => load.pallet_type));

export default getAllTypes;
